import { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { appDestination } from "@/lib/appLinks";

// Website and native customers use the same app, authentication and records.
// Never silently fall back to the retired website-only business database.
export default function AppDestination({ destination, label }) {
  const people = !destination.startsWith("/control") && !destination.startsWith("/business");
  const href = appDestination(process.env.REACT_APP_APP_URL, destination, window.location.origin);
  useEffect(() => { if (!people && href) window.location.replace(href); }, [href, people]);
  if (people) return <Navigate to="/download" replace />;
  return <section className="container-x py-24 text-center">
    <h1 className="font-heading text-3xl font-bold">{href ? `Opening ${label}` : `${label} is being prepared`}</h1>
    <p className="mx-auto mt-4 max-w-lg text-bodygrey">{href
      ? "Your website and app access use the same account."
      : "Online access will be available here when the updated app is published. Please contact us if you need help accessing your existing account."}</p>
    {href ? <a href={href} className="mt-7 inline-flex rounded-full bg-teal px-7 py-3 font-semibold text-white">Continue to {label}</a>
      : <Link to="/support" className="mt-7 inline-flex rounded-full bg-teal px-7 py-3 font-semibold text-white">Contact support</Link>}
  </section>;
}
